import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { BehaviorSubject, of } from "rxjs";
import { dialogDTO } from "../shared/interfaces/shared.interface";

@Injectable({ providedIn: "root" })
export class SharedService {
  dialogDataSubject: BehaviorSubject<dialogDTO> = new BehaviorSubject<dialogDTO>({ title: "", message: "" });

  loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private pendingRequests = 0;

  incrementPending() {
    this.pendingRequests++;
    if (this.pendingRequests === 1) this.loaderSubject.next(true);
  }

  decrementPending() {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) this.loaderSubject.next(false);
  }

  constructor(private messageService: MessageService) {}

  get getDialogData() {
    return this.dialogDataSubject.asObservable();
  }

  showDialog(title: string = "", message: string = "", success: boolean = true, sticky: boolean = false) {
    this.messageService.add({
      severity: success ? "success" : "error",
      summary: title,
      detail: message,
      sticky,
    });
  }
  // showDialog(title: string = "", message: string = "Something went wrong") {
  //   this.dialogDataSubject.next({ title, message });
  // }

  hideDialog() {
    this.dialogDataSubject.next({ title: "", message: "" } as dialogDTO);
  }
}
